import { useCallback } from 'react'
import useTrackEvent from './useTrackEvent'
import mParticleSdk, { EventType, SDKEventCustomFlags, SDKEventOptions } from '@mparticle/web-sdk'
import { useInternalAnalytics } from '../../../utils/internalAnalytics'
import { useMParticleEventProperties } from './useMParticleEventProperties'

type TrackUIElementEventFn = (
  eventName: string,
  eventType: EventType,
  eventInfo?: {
    [key: string]: number | string | boolean | null | undefined
  },
  customFlags?: SDKEventCustomFlags,
  eventOptions?: SDKEventOptions,
) => void

/**
 * Used to track 'Button Clicked', 'Link Clicked' and 'Value Selected' events
 */
function useTrackUIElementEvent(): TrackUIElementEventFn {
  const trackEvent = useTrackEvent()
  const mParticleEventProperties = useMParticleEventProperties()

  const { mParticle, consentSynced } = useInternalAnalytics()

  return useCallback(
    (eventName, eventType, eventInfo, customFlags, eventOptions) => {
      if (!mParticle || !consentSynced) {
        return
      }

      const eventInfoWithCommonProperties: mParticleSdk.SDKEventAttrs = {
        ...eventInfo,
        ...mParticleEventProperties,
      }

      const customFlagsWithCommonFlags = {
        ...customFlags,
        'GA4.Title': document.title,
        'GA4.Location': document.location.href,
        'GA4.Referrer': document.referrer,
      }

      trackEvent(
        eventName,
        eventType,
        eventInfoWithCommonProperties,
        customFlagsWithCommonFlags,
        eventOptions,
      )
    },
    [mParticle, consentSynced, mParticleEventProperties, trackEvent],
  )
}

export default useTrackUIElementEvent
